import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilterCoordinationService {
  private closeFiltersSubject = new Subject<string>();
  
  closeFilters$ = this.closeFiltersSubject.asObservable();

  requestCloseOtherFilters(excludeColumnId: string): void {
    this.closeFiltersSubject.next(excludeColumnId);
  }
}